export default __webpack_public_path__ + "fr/static/media/logo-avis-verifies-uk.d9f97f64.png";